import React from 'react';
import { Box, BoxProps } from '@mui/material';

type PageScrollAreaProps = BoxProps & {
  scrollbarColor?: string;
  trackColor?: string;
  scrollbarSize?: number;
};

const PageScrollArea: React.FC<PageScrollAreaProps> = ({
  children,
  scrollbarColor = '#0768c9',
  trackColor = '#d9e1ea',
  scrollbarSize = 12,
  sx,
  ...rest
}) => (
  <Box
    {...rest}
    sx={{
      minHeight: 0,
      overflowY: 'auto',
      scrollbarColor: `${scrollbarColor} ${trackColor}`,
      '&::-webkit-scrollbar': {
        width: scrollbarSize,
        height: scrollbarSize,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: trackColor,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: scrollbarColor,
        borderRadius: 999,
        border: `2px solid ${trackColor}`,
      },
      '&::-webkit-scrollbar-corner': {
        backgroundColor: trackColor,
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default PageScrollArea;
